import React from "react";
import Chip from "@material-ui/core/Chip";
import CloseIcon from "@material-ui/icons/Close";
import mergeClasses from "classnames";
import useStyles from "./styles";

interface Props extends React.ComponentProps<React.ElementType> {
  align?: "left" | "right" | "center";
  avatar?: React.ReactElement;
  clickable?: boolean;
  color?: "default" | "primary" | "secondary" | "error" | "warn";
  icon?: React.ReactElement;
  label?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDelete?: React.EventHandler<any>;
}

const DPChip = (props: Props) => {
  const classes = useStyles();
  const { align = "center", color = "default" } = props;

  const mergedProps = {
    ...props,
    // cannot pass warn or error color down to MUI
    // it must be intercepted and overridden
    className: mergeClasses(props.className, classes[align], {
      [classes.colorError]: color === "error",
      [classes.colorWarn]: color === "error" ? false : color === "warn",
    }),
    color: color === "warn" || color === "error" ? undefined : color,
  };
  // also cannot pass down alignment
  delete mergedProps.align;

  return (
    <Chip
      {...mergedProps}
      variant="outlined"
      deleteIcon={<CloseIcon />}
      classes={{
        root: classes.root,
        label: classes.label,
        deleteIcon: classes.deleteIcon,
        colorPrimary: classes.colorPrimary,
        colorSecondary: classes.colorSecondary,
      }}
    />
  );
};

export default DPChip;
